import { create } from '@theme/create';

export const themed = create(
  new (function () {
    this.wrapper = {
      minHeight: [0, '19px'], // prevent v-jump while loading
      minWidth: '40px',
      mr: [4, 4],
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      '::after': {
        content: '"|"',
        color: 'text',
      },
    };

    this.loader = {
      height: '12px',
      color: 'mediumDarkGray',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
    };

    this.badges = {
      variant: 'flex.row.start.center',
      width: '100%',
      ml: 5,
    };

    // Amount styles
    this.badge = {
      oneTime: {
        variant: 'badges.sellingPlan',
      },
      subscription: {
        variant: 'badges.sellingPlan',
        bg: 'dark',
      },
      sale: {
        variant: 'badges.sellingPlan',
        bg: 'red',
        ml: 3,
      },
    };

    this.price = {
      lineThrough: {
        variant: 'text.base',
        fontSize: ['20px', 3],
        lineHeight: ['22px', '19px'],
        letterSpacing: ['0.4px', 'normal'],
        textDecoration: 'line-through',
        ml: 4,
        color: 'mediumDarkGray',
        fontWeight: '500',
      },

      new: {
        variant: 'text.base',
        fontSize: ['20px', 3],
        lineHeight: ['22px', '19px'],
        letterSpacing: ['0.4px', 'normal'],
        color: 'red',
        fontWeight: '500',
      },

      regular: {
        variant: 'text.base',
        fontSize: ['20px', 3],
        lineHeight: ['22px', '19px'],
        letterSpacing: ['0.4px', 'normal'],
        fontWeight: '500',
      },
    };
  })()
);
